"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'SubTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    isPoint: {
      type: Boolean,
      default: true
    }
  }
};
exports.default = _default;